import { render, staticRenderFns } from "./LabBuffersB.vue?vue&type=template&id=3de776b8&"
import script from "./LabBuffersB.vue?vue&type=script&lang=ts&"
export * from "./LabBuffersB.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports